import * as DataModel from "./data.js"
import * as ThemeModel from "./theme.js"

const data = DataModel.domain.selector,
  theme = ThemeModel.domain.selector

export const selectors = { data, theme }
